.wrapper {
  padding: 20px;
  box-sizing: unset;
}

.title {
  padding-bottom: 10px;
}

.saturation {
  width: 100%;
  position: relative;
  height: 150px;
  background-image: linear-gradient(transparent, black), linear-gradient(to right, white, transparent);
  user-select: none;
}

.saturation-cursor {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 15px var(--shadow);
  box-sizing: border-box;
  transform: translate(-10px, -10px);
}

.hue {
  width: 100%;
  position: relative;
  margin-top: 15px;
  height: 12px;
  background-image: linear-gradient(
    to right,
    rgb(255 0 0),
    rgb(255 255 0),
    rgb(0 255 0),
    rgb(0 255 255),
    rgb(0 0 255),
    rgb(255 0 255),
    rgb(255 0 0)
  );
  user-select: none;
  border-radius: 12px;
}

.hue-cursor {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: var(--shadow);
  box-sizing: border-box;
  transform: translate(-10px, -4px);
}

.remove-color {
  width: 100%;
  position: relative;
  margin-top: 15px;
  text-align: right;
}

.remove-color:hover {
  cursor: pointer;
  text-decoration: underline;
}
